import React, { Component } from 'react';
import { PageLayout, ContentTemplate } from '../../common/components/layout';
import EventListContainer from './components/EventListContainer';
import OldEventListContainer from './components/OldEventListContainer';
import { EventConstants } from '../CustomerConstants';

class EventList extends Component {
  render() {
    const oldEventConstants = { ...EventConstants, pageSize: 10 };
    return (
      <PageLayout>
        <ContentTemplate>
          <div id="contents" className="event-list">
            <EventListContainer {...this.props} {...EventConstants} />
            <OldEventListContainer {...this.props} {...oldEventConstants} />
          </div>
        </ContentTemplate>
      </PageLayout>
    );
  }
}

export default EventList;
